<template>
  <iColumn align="center">
    <iText>Enter the code from your authenticator app, or one of your backup codes</iText>

    <iTextInput
      v-model="code"
      width="fill"
      focus
      @enter="submitCode"
    />

    <iText v-if="twoFactorErrorMessage" variant="error">
      {{ twoFactorErrorMessage }}
    </iText>

    <iButton
      :is-loading="isLoading"
      loading-spinner-position="inside"
      :disabled="isLoading || !code"
      @click="submitCode"
    >
      Verify
    </iButton>

    <iButton
      v-if="hasPasskey"
      variant="secondary"
      left-icon="key"
      :is-loading="isLoading"
      @click="submitPasskey"
    >
      Use a passkey
    </iButton>

    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import PoweredByInspiration from "%/dynamic-component-editor/standard-pages/login-signup-page/join-publication/PoweredByInspiration.vue";
import { mapActions, mapState, mapWritableState } from "pinia";
import { useLoginSignupStore } from "%/dynamic-component-editor/stores/login-signup-store";

export default {
  name: "JoinPublicationTwoFactor",
  components: { PoweredByInspiration },
  data() {
    return {
      code: "",
    };
  },
  computed: {
    ...mapWritableState(useLoginSignupStore, ["twoFactorErrorMessage"]),
    ...mapState(useLoginSignupStore, ["isLoading", "mfaMethods"]),
    hasPasskey() {
      return this.mfaMethods.includes("passkey");
    },
  },
  mounted() {
    this.twoFactorErrorMessage = "";
  },
  methods: {
    ...mapActions(useLoginSignupStore, ["verifyCode", "verifyPasskey"]),
    submitCode() {
      if (!this.code) {
        return;
      }
      this.verifyCode(this.code);
    },
    submitPasskey() {
      this.verifyPasskey();
    },
  },
};
</script>

<style scoped lang="scss">

</style>
